import { themeGet } from 'styled-system';
import styled from 'react-emotion';

export const PriceWrapper = styled('div')`
  margin-left: auto;
  padding-right: 15px;
`;

export const PriceText = styled('span')`
  position: relative;
  font-size: 18px;
  z-index: 1;
  color: ${themeGet('colors.blueDarker')};
  width: auto;
  display: ${props => (props.showPrices ? 'inline-block' : 'none')};
  text-align: right;
  &:after {
    content: '';
    display: block;
    height: 50%;
    left: 1px;
    right: 0;
    position: absolute;
    width: calc(100% + 15px);
    background-color: #bcdefa;
    opacity: 0.6;
    bottom: -2px;
    z-index: -1;
    transform: skewX(-20deg);
  }
`;



// WEBPACK FOOTER //
// ../shop_main/components/price/style.js